
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { ISlide } from "@/models/slide";
import SlidePreview from "@/modules/slides/components/SlidePreview.vue";
import { RootGetters } from "@/store/getters";
import { mapGetters } from "vuex";
import { Observation } from "@/store/reports/models";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  name: "SlideReport",
  components: {
    SlidePreview,
  },
  props: {
    slide: {
      type: Object as PropType<ISlide>,
      required: true,
    },
    observations: {
      type: Array<Observation>,
      required: true,
    },
    comments: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      activeCase: RootGetters.GET_ACTIVE_CASE,
    }),
  },
  emits: {
    navigateToSlide(slide: ISlide): boolean {
      return slide.id !== "";
    },
  },
  methods: {
    selectSlide(payload: { slide: ISlide; alertIndex: number }): void {
      this.$emit("navigateToSlide", {
        slide: payload.slide,
        alertIndex: payload.alertIndex,
      });
    },
  },
});
